import Phaser          from 'phaser';
import PureGameElement from '../../tools/PureGameElement';
import {
    gameWindowSize,
    boatWidthProportion,
    railPadding,
    boatPhysicsBottomMargin
}                      from '../../constants/appConstants';
import spriteBoat      from '../../../assets/img/spriteBoat.png';
import { swapAudio }   from '../../constants/audioConstants';

class Boat extends PureGameElement {
    constructor ( scene, originRail ) {
        super( scene );
        this._currentRail = originRail;
        this._sprite = null;
    }

    get posX () {
        return this._currentRail.leftCenterPosition;
    }

    get posY () {
        return gameWindowSize.height;
    }

    get width () {
        return Math.round( gameWindowSize.width / 100 * boatWidthProportion );
    }

    get height () {
        return this.width;
    }

    get sprite () {
        return this._sprite;
    }

    preload () {
        super.preload();
        this.scene.load.audio( swapAudio.key, swapAudio.source );
        this.scene.load.spritesheet( 'spriteBoat', spriteBoat, {
            frameWidth: 200,
            frameHeight: 200,
            startFrame: 0,
            endFrame: 3,
        } );
    }

    create () {
        super.create();
        this.scene.sound.add( swapAudio.key, swapAudio.data );
        this.scene.anims.create( {
            frameRate: 8,
            yoyo: false,
            repeat: -1,
            key: 'animBoat',
            frames: this.scene.anims.generateFrameNumbers( 'spriteBoat' ),
        } );

        this._sprite = this.scene.add.sprite(
            this.posX,
            this.posY,
            'spriteBoat'
        );
        this._sprite.depth = 10;
        this._sprite.setSize( this.width, this.height );
        this._sprite.setDisplaySize( this.width, this.height );
        this._sprite.setOrigin( 0.5, 1 );
        this._sprite.anims.load( 'animBoat' );
        this._sprite.anims.play( 'animBoat' );

        this.scene.physics.world.enable( this._sprite, Phaser.Physics.Arcade.STATIC_BODY );
        this._sprite.body.width = this._currentRail.width - railPadding;
        this._sprite.body.height = this.height - boatPhysicsBottomMargin;
        this._sprite.body.x = this.posX - this._currentRail.width / 2 + railPadding / 2;
        this._sprite.body.y = gameWindowSize.height - this.height;
        this._sprite.body.setOffset( 0, 0 );
    }

    onMoveLeft () {
        if ( this._sprite && this._currentRail.index > 0 ) {
            this.scene.sound.play( swapAudio.key );
            this._currentRail = this.scene.rails[this._currentRail.index - 1];
            this._sprite.x = this.posX;
            this._sprite.body.x = this.posX - this._currentRail.width / 2 + railPadding / 2;
        }
    }

    onMoveRight () {
        if ( this._sprite && this._currentRail.index < this.scene.rails.length - 1 ) {
            this.scene.sound.play( swapAudio.key );
            this._currentRail = this.scene.rails[this._currentRail.index + 1];
            this._sprite.x = this.posX;
            this._sprite.body.x = this.posX - this._currentRail.width / 2 + railPadding / 2;
        }
    }

}

export default Boat;
